export default {
    update(state, [prop, value]) {
        state[prop] = value;
    },
};
